import React, {useEffect } from "react";
import { Col, Container, Row } from 'reactstrap';
import ReportsPatientsFilter from './components/ReportsPatientsFilter';

const ReportsPatients = ({ }) => {
    
    useEffect(() => {
        
    }, []);

    return (
        <Container className="dashboard">
            <Row>
                <Col md={12}>
                    <h3 className="page-title center-title">Reporte General de Pacientes</h3>
                </Col>
            </Row>
            <ReportsPatientsFilter/>
        </Container>
    );
}
export default ReportsPatients;